import { scheduled } from '../scheduled/scheduled';
import { innerFrom } from './innerFrom';
export function from(input, scheduler) {
    return scheduler ? scheduled(input, scheduler) : innerFrom(input);
}
